'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');

const getAccordionItemChildrenCss = ({
  headerStyle,
  contentStyle,
  contentAlign
}) => {
  const getHorizontalAlign = () => {
    if (!contentAlign)
      return "";
    let alignStyle = "stretch";
    if (contentAlign === coreRenderer.Alignment.center)
      alignStyle = "center";
    if (contentAlign === coreRenderer.Alignment.right)
      alignStyle = "flex-end";
    return `align-items: ${alignStyle};`;
  };
  return `
  .accordion {
    &__header {
      ${coreRenderer.getStyle(headerStyle)}
    }

    &__content {
      ${coreRenderer.getStyle(contentStyle)}
      ${getHorizontalAlign()}
    }
  }
`;
};

exports.getAccordionItemChildrenCss = getAccordionItemChildrenCss;
